import {CDN_IMAGE_URL, VIEWPORT_WIDTHS} from 'configs';
import {useViewport} from 'contexts/ViewportContext';
import React from 'react';
import urlJoin from 'url-join';

export default function LandingAsset() {
  const {size} = useViewport();
  const isMobile = VIEWPORT_WIDTHS[size] < VIEWPORT_WIDTHS['lg'];

  const IMAGE_URL = urlJoin(
    CDN_IMAGE_URL,
    isMobile
      ? 'p/landing/bulk-import-que-1x-mobile.webp'
      : 'p/landing/bulk-import-que-1xv1.webp'
  );

  return (
    <div className="d-flex align-items-center justify-content-center">
      <img
        width={isMobile ? 298 : 487}
        height={isMobile ? 233 : 380}
        src={IMAGE_URL}
        alt="Landing Asset"
        loading="lazy"
      />
    </div>
  );
}
